import React from 'react';
import {makeStyles} from '@mui/styles';
import {Button, Grid, Typography} from '@mui/material';
import {history} from '../../../helpers/history';
import { licensingActions, userActions } from '../../../store/actions';
import { useDispatch, useSelector } from 'react-redux';
import { SECURITY_ROLES } from '../../../constants/SECURITY_ROLES';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4),
    height: '100%',
    backgroundColor: theme.palette.white,
  },
  content: {
    height: '100%',
    marginTop: 50,
    textAlign: 'center'
  },
  image: {
    marginTop: 20,
    display: 'inline-block',
    maxWidth: '100%',
    width: 560
  },
  button: {
    margin: theme.spacing(1),
    color: theme.palette.white,
    backgroundColor: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: theme.palette.secondary.light

    }
  },
}));

const LicenseError = (props) => {
  const { errorCode, errorMessage } = props.location.state;
  const classes = useStyles();
  const dispatch = useDispatch();

  const user = useSelector(state => state.authentication.user);

  const handleContinue = () => {
    dispatch(userActions.logout(user));
  }

  const handleUploadLicense = () => {
    history.push({
      pathname: '/license/upload',
    });
  }

  async function getRandomPhrase(){
    return dispatch(licensingActions.generateRandomPhrase()).then(licensing =>{
      return (licensing);
    });
  }

  const handleRequestLicense = async () => {
    let license = await getRandomPhrase();
    history.push({
      pathname: '/license/request',
      state: {
        requestType: 'New',
        randomPhrase: license.random_phrase,
        request_filename: license.new_filename
      }
    });
  }

  return (
    <div className={classes.root}>
      <Grid
        container
        justifyContent="center"
        spacing={4}
      >
        <Grid
          item
          lg={6}
          xs={12}
        >
          <div className={classes.content}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography variant="h4" style={{padding:10}}>
                  An Error Has Occurred!
                </Typography>
                <Typography variant="h1" style={{padding:10}}>
                  {errorMessage}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Button xs={6} onClick={handleContinue} className={classes.button}>
                  Continue
                </Button>
                {/*{(user.role.toLowerCase().includes('admin')) &&*/}
                {(user.availableRoles.includes(SECURITY_ROLES.COMPANY_ADMIN)) &&
                  <Button xs={6} onClick={handleRequestLicense} className={classes.button}>
                    Request/Upload License
                  </Button>
                }
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default LicenseError;
